module.exports = __webpack_public_path__ + "images/19dee5fbf23d53c098e7e436711093d1.svg";